<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
    <div [innerHtml]="message"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <forge-button variant="outlined" (click)="cancel()" telemetry="Submission-Cancel">
        {{cancelLabel}}
    </forge-button>

    <forge-button variant="raised" (click)="accept()" telemetry="Submission-Save">
        {{okLabel}}
    </forge-button>
</mat-dialog-actions>